import axios from "axios";
import { getTokenHeader } from "@/helpers/commonHelper";
const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);

export default {
  name: "ApiManagement",
  data() {
    return {
      apiKeys: [],
      form: {
        name: "",
        key: "",
        url: "",
        model: "",
        shared: false,
        provider: "OpenAI" // default
      },
      providerOptions: [
        { label: "OpenAI", value: "OpenAI" },
        { label: "Anthropic", value: "Anthropic" },
        { label: "Google Gemini", value: "Google Gemini" },
        { label: "OpenRouter", value: "OpenRouter" }
      ],
      isEditing: false,
      editingId: null,
      deleteDialog: false,
      keyToDelete: null,
      showForm: false
    };
  },
  created() {
    this.$store.dispatch("getCurrentUser");
    this.fetchKeys();
  },
  methods: {
    async fetchKeys() {
      try {
        const headers = getTokenHeader();
        const params = {
          principal_id: this.currentPrincipal
        };
        const res = await axios.get(
          `${env.prompts_api_client_url}api/eo-prompt/keys`,
          { params, headers }
        );
        this.apiKeys = (res.data || []).map(k => ({
          ...k,
          provider: k.provider || "OpenAI"
        }));
      } catch (err) {
        console.error("Failed to fetch API keys:", err);
      }
    },
    async addKey() {
      if (!this.form.name || !this.form.key) return;
      try {
        const headers = getTokenHeader();
        const params = {
          principal_id: this.currentPrincipal
        };
        await axios.post(
          `${env.prompts_api_client_url}api/eo-prompt/keys`,
          this.form,
          { params, headers }
        );
        await this.resetForm();
        await this.fetchKeys();
      } catch (err) {
        console.error("Failed to add API key:", err);
      }
    },
    async editKey(key) {
      this.form = {
        name: key.name,
        key: key.fullKey || "",
        url: key.url || "",
        model: key.model || "",
        provider: key.provider || "OpenAI",
        shared: key?.shared || false
      };
      this.editingId = key._id;
      this.isEditing = true;
      this.showForm = true;
      await this.$nextTick();
      this.scrollToApiForm();
    },
    scrollToApiForm() {
      const target = this.$refs.apiFormSection;
      if (target?.$el?.scrollIntoView) {
        target.$el.scrollIntoView({ behavior: "smooth", block: "start" });
        return;
      }
      if (target?.scrollIntoView) {
        target.scrollIntoView({ behavior: "smooth", block: "start" });
        return;
      }
      if (typeof window !== "undefined") {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    },
    async copyKey(key) {
      await this.resetForm();
      await this.editKey(key);

      this.form.name = key.name + " (Copy)";
      this.form.key = ""; // !! important
      this.form.shared = false; // !! important
      this.form.provider = key.provider;
      this.isEditing = false;
      this.showForm = true;
      await this.$nextTick();
      this.scrollToApiForm();
    },
    async updateKey() {
      if (!this.editingId) return;
      try {
        const headers = getTokenHeader();
        const params = {
          principal_id: this.currentPrincipal
        };
        await axios.put(
          `${env.prompts_api_client_url}api/eo-prompt/keys/${this.editingId}`,
          this.form,
          { params, headers }
        );
        await this.resetForm();
        await this.fetchKeys();
      } catch (err) {
        console.error("Failed to update API key:", err);
      }
    },
    async cancelEdit() {
      await this.resetForm();
    },
    async resetForm() {
      this.form = {
        name: "",
        key: "",
        url: "",
        model: "",
        provider: "OpenAI",
        shared: false
      };
      this.editingId = null;
      this.isEditing = false;
      this.showForm = false;
    },
    async confirmDelete(key) {
      this.keyToDelete = key;
      this.deleteDialog = true;
    },
    async deleteKey() {
      try {
        const headers = getTokenHeader();
        const params = {
          principal_id: this.currentPrincipal
        };
        await axios.delete(
          `${env.prompts_api_client_url}api/eo-prompt/keys/${this.keyToDelete._id}`,
          { params, headers }
        );
        this.deleteDialog = false;
        this.keyToDelete = null;
        await this.fetchKeys();
      } catch (err) {
        console.error("Failed to delete API key:", err);
      }
    }
  },
  computed: {
    currentPrincipal() {
      return this.$store.state.selectedPrincipal.id;
    },
    isAdmin() {
      return this.$store.state.currentUser?.scopes.includes("role:admin");
    }
  },
  watch: {
    currentPrincipal() {
      this.fetchKeys();
    }
  }
};
